"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.countDecimals = exports.roundNumber = exports.mapIterable = exports.actualTypeOf = exports.isPlainObject = void 0;
// source https://stackoverflow.com/a/38555871/984137
var isPlainObject = function (value) {
    return (typeof value === 'object' && // separate from primitives
        value !== null && // is obvious
        value.constructor === Object && // separate instances (Array, DOM, ...)
        Object.prototype.toString.call(value) === '[object Object]' // separate build-in like Math
    );
};
exports.isPlainObject = isPlainObject;
var actualTypeOf = function (value) {
    if (typeof value === 'object') {
        if (value === null) {
            return 'null';
        }
        if (value.constructor === Object && Object.prototype.toString.call(value) === '[object Object]') {
            return 'object';
        }
        var constructorName = value.constructor.name;
        if (typeof constructorName === 'string' && constructorName !== 'Object' && constructorName.length > 0) {
            return constructorName;
        }
        var objectStr = Object.prototype.toString.call(value);
        var innerName = objectStr.split(' ')[1];
        if (typeof innerName === 'string') {
            return innerName;
        }
        else {
            return '';
        }
    }
    else {
        return typeof value;
    }
};
exports.actualTypeOf = actualTypeOf;
function mapIterable(iterable, mapper) {
    var iterable_1, iterable_1_1, item, e_1_1;
    var e_1, _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 5, 6, 7]);
                iterable_1 = __values(iterable), iterable_1_1 = iterable_1.next();
                _b.label = 1;
            case 1:
                if (!!iterable_1_1.done) return [3 /*break*/, 4];
                item = iterable_1_1.value;
                return [4 /*yield*/, mapper(item)];
            case 2:
                _b.sent();
                _b.label = 3;
            case 3:
                iterable_1_1 = iterable_1.next();
                return [3 /*break*/, 1];
            case 4: return [3 /*break*/, 7];
            case 5:
                e_1_1 = _b.sent();
                e_1 = { error: e_1_1 };
                return [3 /*break*/, 7];
            case 6:
                try {
                    if (iterable_1_1 && !iterable_1_1.done && (_a = iterable_1.return)) _a.call(iterable_1);
                }
                finally { if (e_1) throw e_1.error; }
                return [7 /*endfinally*/];
            case 7: return [2 /*return*/];
        }
    });
}
exports.mapIterable = mapIterable;
function roundNumber(num, scale) {
    if (scale === 0) {
        return Math.round(num);
    }
    if (num.toString().includes('e') === false) {
        return +(Math.round(num + "e+" + scale) + 'e-' + scale);
    }
    else {
        var arr = ('' + num).split('e');
        var sig = '';
        // @ts-ignore
        if (+arr[1] + scale > 0) {
            sig = '+';
        }
        // @ts-ignore
        return +(Math.round(+arr[0] + "e" + sig + (+arr[1] + scale)) + 'e-' + scale);
    }
}
exports.roundNumber = roundNumber;
function countDecimals(value) {
    var _a;
    if (Math.floor(value.valueOf()) === value.valueOf()) {
        return 0;
    }
    else {
        return ((_a = value.toString().split('.')[1]) === null || _a === void 0 ? void 0 : _a.length) || 0;
    }
}
exports.countDecimals = countDecimals;
